import styled from 'styled-components';
import { Text } from 'grommet';

const TextBold = styled(Text)`
  font-weight: bold;
`;

export default TextBold;
